module.exports = "/assets/packs/images/a920a2404bd42b6a7fcb3e74e97a61d2.png";